<header class="header text-center">
    <img src="assets/images/logo.png" alt="logo">
</header>

<section>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-sm-10 text-center">
                <div class="boxConainer" *ngIf="userAgent=='Chrome'">
                    <div class="skipOptDiv"> <button *ngIf="submitbuttonShow" class="btn btn-link" type="button"
                            (click)="onSkip()">
                            Will do later </button></div>
                    <img src="assets/images/pragti-img.svg" alt="pragti-img">
                    <!-- <h1>PIVC</h1>  ETLI Zindagi Plus-->
                    <!-- <p>Pre-Issuance verification</p> -->
                    <p>Congratulations
                        <span>{{ policyHoldername }}</span> for chosing <span>{{ planName }} - {{productType}}</span>
                        Plan.
                    </p>
                    <p>We will begin with Pre-Issuance Video Verification for your application no
                        <span>{{ policyNumber }}</span>.<br> Please switch on your camera.
                    </p>
                    <hr class="dash-line">
                    <br>
                    <div class="row">
                        <div class="col-sm-12 text-center">
                            <div class="media" style="display: inline-flex !important;">
                                <img style="display: inline-flex;" src="assets/images/language1.svg" alt="language1">
                                <div class="media-body">
                                    <h5 class="mt-0">Choose your preferred language to complete PIVC </h5>
                                </div>
                            </div>
                            <ul class="languageButtons " style="text-align: -webkit-center;">
                                <li class="col-xl-2 col-md-3 col-sm-4 col-6"
                                    *ngFor="let language of langList | keyvalue">
                                    <button type="button" class="btn btn-outline-secondary"
                                        (click)="languageSelection(language.key)"
                                        [ngClass]="{'active': langButton === language.key}">{{ language.value
                                        }}</button>
                                </li>
                            </ul>

                        </div>
                    </div>
                    <button *ngIf="submitbuttonShow" class="btn btn-lg mr-1" type="button" (click)="onSubmit()"> Start
                        PIVC</button>
                    <p><small>Having Trouble? <a routerLink="/contact-us">Contact Here</a> </small></p>
                </div>
                <div class="boxConainer" *ngIf="userAgent!='Chrome'" style="height: 300px;">
                    <div style="margin-top: 100px; ">
                        <h6>Please Use Google Chrome</h6>
                        <div class="text-center">
                            <img src="../../assets/images/chrome-icon.png" width="50">
                        </div>
                        <small>version above 70.0</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>